import React, { Component } from "react";
import { Checkbox } from "antd";
import PropTypes from "prop-types";
import "antd/dist/antd.css";
import avatarImg from "./img/default_nor_avatar.png";

class FansManageList extends Component {
  // 默认属性
  static defaultProps = {
    newSecondSelectColor: "#0050B3",
  };
  // 静态类型分析
  static propTypes = {
    avatar: PropTypes.string, //头像
    name: PropTypes.string.isRequired, //名称
    sex: PropTypes.number.isRequired, //性别
    region: PropTypes.string, //地区
  };
  constructor(props) {
    super(props);
    this.state = {
      checked: false, //是否选中
    };
  }
  render() {
    return (
      <div style={{ width: "100%" }}>
        <table
          style={{
            border: "1px solid #666",
            textAlign: "center",
          }}
        >
          <tbody>
            <tr
              style={{
                border: "1px solid #e6e6e6",
                height: "15px",
                lineHeight: "15px",
              }}
            >
              <td
                style={{
                  width: "48px",
                  borderRight: "1px solid #e6e6e6",
                }}
              >
                <Checkbox
                  style={{ padding: "10px" }}
                  checked={this.props.checked} //拿到父组件内部子组件的checked方法
                  onClick={(e) => {
                    this.props.ItemClick(); //点击子组件时拿到父组件内部子组件的方法
                  }}
                />
              </td>
              <td style={{ width: "360px" }}>
                <img
                  style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                  src={
                    this.props.avatar === null ? avatarImg : this.props.avatar
                  }
                  alt=""
                />
              </td>
              <td style={{ width: "360px", overflow: "hidden", textOverflow: "ellipsis", lineClamp: 1, whiteSpace: "nowrap" }}>{this.props.name}</td>
              <td style={{ width: "360px" }}>
                {this.props.sex === 1 ? "男" : "女"}
              </td>
              <td style={{ width: "360px" }}>
                {this.props.region === null ? "未知" : this.props.region}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default FansManageList;
